<template>
  <div>
    <div class="header">
      <div>
        <h1>Estimated Revenue</h1>
        <p class="small text-muted">We calculate your estimated revenue by adding up purchases made by your clients up to 5 days after they have clicked a link on your email.</p>
      </div>
      <form @submit.prevent v-if="!loading && results.length">
        <div class="input-group" v-if="">
          <span class="input-group-addon">
            <span class="icon icon-search"></span>
          </span>
          <input type="search" name="query" v-model.trim="query" class="form-control" placeholder="Search" />
        </div>
      </form>
    </div>
    <div class="datatable" v-if="!loading && results.length">
      <table class="table bb-datatable">
        <thead>
          <tr>
            <td>Email Address</td>
            <td>Pricing Option</td>
            <td class="text-right">Estimated Revenue</td>
          </tr>
        </thead>
        <tbody>
          <tr v-if="loading">
            <td class="text-center" colspan="2"><i class="fa fa-spin fa-spinner fa-fw"></i></td>
          </tr>
          <tr v-for="result in filteredResults" v-if="!loading">
            <td>
              <router-link :to="'/contacts/' + result.contact_uuid">{{ result.email }}</router-link>
            </td>
            <td>{{ result.pricing_option_name }}</td>
            <td class="text-right">{{ result.revenue | prettyCurrency }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="illustration" v-if="!loading && !results.length">
      <img src="https://assets.brandbot.com/public/empty-states/est-revenue.svg" />
    </div>
  </div>
</template>
<script>
  import * as api from '@/api';

  export default {
    props: ['typeUuid'],
    data() {
      return {
        loading: true,
        results: [],
        query: '',
      };
    },
    created() {
      api.emailPerformanceContacts(this.typeUuid, 'revenue').then((response) => {
        this.results = response.contacts;
        this.loading = false;
      }).catch((err) => {
        this.$toasted.error(err.message);
      });
    },
    computed: {
      filteredResults() {
        if (this.query.length) {
          return this.results.filter(r =>
            r.email.toLowerCase().indexOf(this.query.toLowerCase()) > -1,
          );
        }

        return this.results;
      },
    },
  };
</script>
<style lang="scss" scoped>
  .header {
    margin-top: 1.25rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  h1 {
    text-transform: capitalize;
    font-size: 1.25rem;
    font-weight: normal;
    color: #212B36;
    line-height: 1.5rem;
  }

  .illustration img {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 10rem;
    margin-bottom: 2rem;
  }

  .datatable .bb-datatable tbody tr td:first-child {
    max-width: none;
    width: auto;
  }

  p {
    max-width: 30rem;
  }
</style>
